/**
 * Namenseingabe als Reibung vor einer Aktion, die beim Kanalmanager wirkt.
 *
 * PO-Vorgabe: „Solche Aktionen wie Pausieren und Archivieren dürfen nicht so einfach ausgeführt
 * werden." Ein Bestätigungsdialog allein reicht dafür nicht — er wird weggeklickt. Den Namen zu
 * tippen zwingt dazu, zu lesen, **welches** Apartment gemeint ist; genau der Fehler, den ein
 * Dialog sonst durchwinkt.
 *
 * Verglichen wird getrimmt und ohne Groß-/Kleinschreibung: die Hürde soll Unachtsamkeit abfangen,
 * nicht Tippgenauigkeit prüfen.
 */
interface NameConfirmationProps {
  expectedName: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  /** Wovon der Name ist — steht nur im Screenreader-Label. */
  subjectLabel?: string;
}

export function namesMatch(expected: string, typed: string): boolean {
  return typed.trim().toLocaleLowerCase() === expected.trim().toLocaleLowerCase();
}

export function NameConfirmation({
  expectedName,
  value,
  onChange,
  disabled,
  subjectLabel = 'Apartments',
}: NameConfirmationProps) {
  const matches = namesMatch(expectedName, value);
  return (
    <label className="text-ink-soft block text-sm">
      Tippe zur Bestätigung <span className="text-ink font-semibold">{expectedName}</span> ein
      <input
        type="text"
        value={value}
        disabled={disabled}
        autoComplete="off"
        aria-label={`Name des ${subjectLabel} zur Bestätigung: ${expectedName}`}
        onChange={(event) => onChange(event.target.value)}
        className="border-line bg-card text-ink mt-2 w-full rounded-md border px-3 py-2"
        placeholder={expectedName}
      />
      {value.length > 0 && !matches && (
        <span className="text-sealwax mt-1 block text-xs">Der Name stimmt noch nicht überein.</span>
      )}
    </label>
  );
}
